import React from 'react';
import PropTypes from 'prop-types';
import {withStyles} from '@material-ui/core/styles';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import {withRouter} from 'react-router-dom';

const styles = theme => ({
    root: {
        width: '100%'
    },
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular
    }
});

const ItemExpansion = (props) => {
  const {classes, subModule, pages, history}   = props;
  return(
      <div className={classes.root}>
        
      </div>
  );
};

ItemExpansion.prototype = {
    classes: PropTypes.object.isRequired,
    subModule: PropTypes.object,
    pages: PropTypes.object,
    history: PropTypes.object.isRequired
};

export default withRouter(withStyles(styles)(ItemExpansion));